import FontBody2 from '../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';

interface ITooltipContentProps {
    content: string;
}

const TooltipContent: React.FC<ITooltipContentProps> = ({ content }) => {
    return (
        <FontBody2 color={FONT_COLOR.NEUTRAL_1_WHITE} variant={FONT_VARIANT.DEFAULT}>
            {content}
        </FontBody2>
    );
};

export default TooltipContent;
